import { type ReactNode } from 'react';

interface PageShellProps {
  children: ReactNode;
  className?: string;
}

export function PageShell({ children, className = '' }: PageShellProps) {
  return (
    <div className={['page-shell', className].filter(Boolean).join(' ')}>
      {children}
    </div>
  );
}

export default PageShell;
